import http from '../httpService';

class CountryService {
    public async getCountries() {
        let result = await http.get('api/v1/utility/countries');
        return result.data;
    }
}

export default new CountryService();